var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "24/search"
  }, /*#__PURE__*/React.createElement("path", {
    id: "icon",
    d: "M19.73 18.4098L15.94 14.6198C16.74 13.5698 17.22 12.2598 17.22 10.8498C17.22 7.39984 14.41 4.58984 10.96 4.58984C7.50995 4.58984 4.69995 7.39984 4.69995 10.8498C4.69995 14.2998 7.50995 17.1098 10.96 17.1098C12.27 17.1098 13.49 16.6998 14.5 16.0098L18.32 19.8298L19.73 18.4198V18.4098ZM6.68995 10.8498C6.68995 8.49984 8.59995 6.58984 10.95 6.58984C13.3 6.58984 15.21 8.49984 15.21 10.8498C15.21 12.0198 14.74 13.0798 13.97 13.8498L13.95 13.8698C13.18 14.6398 12.12 15.1098 10.95 15.1098C8.59995 15.1098 6.68995 13.1998 6.68995 10.8498Z",
    fill: "#727272"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.8d0ac3f9dba6eedafae2ab6e7583438f.svg";
export { ForwardRef as ReactComponent };